/* eslint-disable react/jsx-boolean-value */
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CardAction from '../../../../components/card/CardAction';
import { useAddRemoveFromGroupPlay } from './AddRemoveFromGroupPlayHooks';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './RemoveFromGroupPlay.scss';

/**
 * Share Link Lesson Action Container
 */
const defaultProps = {
  onSaveSuccess: () => { },
};

export default function RemoveFromGroupPlay(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, onSaveSuccess } = mergedProps;
  const { removeLessonFromGroupPlay } = useAddRemoveFromGroupPlay(lesson, onSaveSuccess);
  const handleOnRemoveFromGroupPlay = () => {
    removeLessonFromGroupPlay();
  };

  return (
    <CardAction
      icon={<RemoveCircleIcon aria-hidden='false' />}
      label='GROUP INSTRUCTION'
      ariaLabel='Remove from Group Instruction'
      title='Remove from Group Instruction'
      className='remove-from-group-play-action'
      actionHandler={handleOnRemoveFromGroupPlay}
      data-test='remove-from-group-play-action'
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
